<template>
	<div class="merchant_info mb_10">
		<router-link
			to
			@click="modalMerchant = true"
			class="d_flex justify_between align_items_center"
			>{{ $store.state.auth.merchantInfo.merchant_name }} /
			{{ $store.state.auth.merchantInfo.merchant_id }}
			<span class="merchant_select_trigger_icon"></span
		></router-link>
	</div>
	<div class="d_flex">
		<div class="mr_10 w60">
			<div class="card type1">
				<h3 class="title">{{ $t('merchant.title1') }}</h3>
				<div class="chart_wrap">
					<PaymentStatisticsChart
						ref="barChart"
						:range-date="rangeDate"
					></PaymentStatisticsChart>
				</div>
			</div>
		</div>
		<div class="box_right w40">
			<div class="card type2">
				<h3 class="title">{{ $t('merchant.title2') }}</h3>
				<div>
					<div class="mt_20">
						<DatePicker
							is-expanded
							is-range
							style="border: none"
							v-model="rangeDate"
							:locale="$store.state.common.locale"
						></DatePicker>
					</div>
				</div>
			</div>
			<div class="card mb_0 type3">
				<h3 class="title">{{ $t('merchant.title4') }}</h3>
				<router-link
					:to="{ name: 'merchant-console-cs-notice' }"
					class="icon_position more"
				></router-link>
				<div class="mt_20">
					<ul class="notice">
						<li v-for="item in noticeList" :key="item.seq">
							<router-link :to="{ name: 'merchant-console-cs-notice' }">
								<p class="title">{{ item.title }}</p>
								<p class="date">
									{{ $dayjs(item.regdate).format('YYYY.MM.DD') }}
								</p>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
	<ModalView
		add-class="merchant"
		v-if="modalMerchant"
		@closeModal="modalMerchant = false"
	>
		<MerchantPicker
			@selectMerchant="selectMerchant"
			@closeModal="modalMerchant = false"
		></MerchantPicker
	></ModalView>
</template>
<script>
import PaymentStatisticsChart from '@/components/PaymentStatisticsChart';
import { fetchFaqList, fetchFaqTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';
import ModalView from '@/components/Layout/ModalView';
import MerchantPicker from '@/components/Merchant/MerchantPicker';

export default {
	name: 'Catalog',
	components: { PaymentStatisticsChart, ModalView, MerchantPicker },
	data() {
		return {
			date: new Date(),
			rangeDate: {
				start: this.$dayjs(new Date()).add(-7, 'd').toDate(),
				end: this.$dayjs(new Date()).toDate(),
			},
			noticeList: [],
			modalMerchant: false,
			faqTypeList: [],
		};
	},
	computed: {
		faqNotice() {
			return this.faqTypeList.find(item => {
				return item.name.toLowerCase() === 'notice';
			});
		},
	},
	watch: {
		rangeDate: {
			handler(val) {
				this.rangeDate = val;
			},
			deep: true,
		},
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			Promise.all([this.loadFaqTypeList()]).then(() => {
				this.loadNoticeList();
			});
		},
		async loadFaqTypeList() {
			const { data } = await fetchFaqTypes().catch(commonError);
			this.faqTypeList = data;
		},
		async loadNoticeList() {
			const params = {
				type_seq: this.faqNotice.seq,
				page_count: 3,
			};
			const { data } = await fetchFaqList(params).catch(commonError);
			this.noticeList = data;
		},
		selectMerchant(obj) {
			this.toRoute(obj);
			this.$store.dispatch('auth/getMerchantInfo', obj.params.merchant_seq);
			this.modalMerchant = false;
		},
		toRoute(obj) {
			// this.isMenuOpen = false;
			this.$router.push(obj);
		},
	},
};
</script>
<style>
.menu_item {
	display: flex;
	flex-direction: column;
	text-align: center;
	cursor: pointer;
}
.menu_item:hover .icon {
	opacity: 1;
}
.menu_item .icon {
	width: 100px;
	height: 100px;
	border-radius: 50%;
	transition: 0.5s;
	opacity: 0.3;
}
.menu_item .menu_title {
	margin-top: 10px;
	font-size: 13px;
}
.notice {
	border-top: 1px solid #1e1e1e;
}
.notice li {
	/* padding: 13px; */
	/* border-bottom: 1px solid #ddd; */
}
.notice li a {
	display: flex;
	justify-content: space-between;
}
.notice .title {
	font-size: 14px;
	color: #333;
}
.notice .date {
	font-size: 14px;
	color: #868686;
}
.vc-day {
	min-height: 50px !important;
}
</style>
